export default __webpack_public_path__ + "static/media/eternity_reaching_out.29787a10.txt";